import { IIconProps } from '~/types';

const DashboardIcon = ({ fill = '#7B7986', ...props }: IIconProps) => (
  <svg
    width={25}
    height={24}
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#a)">
      <path
        d="M19.5 5v2h-4V5zm-10 0v6h-4V5zm10 8v6h-4v-6zm-10 4v2h-4v-2zm12-14h-8v6h8zm-10 0h-8v10h8zm10 8h-8v10h8zm-10 4h-8v6h8z"
        fill={fill}
      />
    </g>
  </svg>
);
export default DashboardIcon;
